const theme = {
  name: 'Würth',
  fontFamily: 'Wuerth',
  boxShadow: '0 2px 12px 0 rgba(153, 153, 153, 0.24)',
  boxShadowAlternative: '0 2px 24px 0 rgba(153, 153, 153, 0.2)',
  colorBlack: '#0d0c0e',
  colorWhite: '#ffffff',
  colorBlackAlternative: '#333333',
  colorDividerGrey: '#eeeeee',
  colorFootnoteGrey: '#8b8690',
  colorRed: '#e30613',
  colorRedLight: 'rgba(227, 6, 19, 0.32)',
  colorBlackLight: 'rgba(51, 51, 51, 0.2)',
  colorRedTransparent: 'rgba(226, 0, 26, 0.16)',
  colorLabelTitleGrey: '#656565',
  colorSelectGrey: '#403c43',
  colorBackgroundGrey: '#f7f7f7',
  colorBackgroundGreyDarker: '#e1e1e1',
  colorTachoGrey: '#2b2e34',
  borderRadius: '4px',
  fontSize: {
    tiny: '1rem',
    small: '1.2rem',
    normal: '1.4rem',
    regular: '1.6rem',
    big: '1.8rem',
    bigger: '2rem',
    bigNumber: '2.4rem',
    biggest: '2.8rem',
    huge: '6.4rem',
  },
}

export default theme
